import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete, apiPut, request} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import { getErrorMessage, mustBeArray, requestHasError } from '../utils/lib';
import FileSaver from 'file-saver';
import moment from 'moment';

export function listRebatesRCTISuccess({items, total}){
  return {type: types.LIST_REBATES_RCTI_SUCCESS, items, total};
}

export function clearRebatesRCTISuccess(){
  return {type: types.CLEAR_REBATES_RCTI_SUCCESS, items: [], total: 0};
}

export function listRCTIInvoicesSuccess({items, total}){
  return {type: types.LIST_RCTI_INVOICES_SUCCESS, items, total};
}

export function clearRCTIInvoicesSuccess(){
  return {type: types.CLEAR_RCTI_INVOICES_SUCCESS, items: [], total: 0};
}

export function getRebatesRCTIDetailSuccess(data){
  return {type: types.GET_REBATES_RCTI_DETAIL_SUCCESS, data};
}

export function clearRebatesRCTIDetailSuccess(){
  return {type: types.CLEAR_REBATES_RCTI_DETAIL_SUCCESS, data: {}};
}

export function listRebatesRCTI({dateFrom, dateTo, clientName=null, statusID}) {
  return function (dispatch) {
    return apiRequest(`/api/rebateRcti?clientName=${clientName||""}&dateFrom=${dateFrom||null}&dateTo=${dateTo||null}&statusID=${statusID||""}`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error while fetching rebates RCTI, error: ${getErrorMessage({x})}`);
          dispatch(clearRebatesRCTISuccess());
        } else {
          dispatch(listRebatesRCTISuccess({items: Array.from(x.data), total: x.total}));
        }
        return x;
      });
  };
}

export function listRebatesRCTIInvoices({dateFrom, dateTo, clientId=null}) {
  return function (dispatch) {
    let selectedClients = mustBeArray(clientId).includes("All") || _.isEmpty(mustBeArray(clientId)) ? `clientId=${""}` : mustBeArray(clientId).reduce((a,b) => {
      return a ? `${a}&clientId=${b}` : `clientId=${b}`;
    },"");
    return apiRequest(`/api/locations/clientlocations?${selectedClients}&dateFrom=${dateFrom||null}&dateTo=${dateTo||null}`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Client Location Error, error: ${getErrorMessage({x})}`);
          dispatch(clearRCTIInvoicesSuccess());
        } else {
          dispatch(listRCTIInvoicesSuccess({items: mustBeArray(x.data && x.data.locations), total: x.total}));
        }
        return x;
      });
  };
}

export function clearRebatesRCTIInvoices() {
  return function (dispatch) {
    return dispatch(clearRCTIInvoicesSuccess());
  };
}

export function getRebatesRCTIDetail({id}) {
  return function (dispatch) {
    return apiRequest(`/api/rebateRCTI/view?id=${id}`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error while fetching rebates RCTI, error: ${getErrorMessage({x})}`);
        } 
        return x;
      });
  };
}

export function updateRebatesRCTIListFilters(filters) {
  return function (dispatch, getState) {
    return dispatch({data: filters, type: types.UPDATE_REBATES_RCTI_LIST_FILTERS_SUCCESS});
  };
}

export function exportRebatesRCTI({rebates}) {
  return function (dispatch) {
    toastr.info("Rebates RCTI: Exporting");
    const singleExport = rebates.length === 1;
    const url = singleExport ? `/api/rebatercti/export?id=${rebates[0]}` :
                `/api/rebatercti/bulkexport?ids=${rebates.join(",")}`;
    return apiRequest(url,"GET")
      .then(x => {
        if (requestHasError({x}) && singleExport) {
            toastr.error(`Export Error, error: ${getErrorMessage({x})}`);
        } 
        return x;
      });
    };
}

export function deleteRebatesRCTI({id}) {
  return function (dispatch) {
    return apiDelete(`/api/rebateRCTI/${id}`)
      .then(x => {
        return x;
      });
    };
}

export function bulkDownloadRebatesRCTI({dateFrom, dateTo, clientName=null, statusID}) {
  return function (dispatch) {
    toastr.info("Generating RCTI Rebates CSV.");
    return apiRequest(`/api/rebateRCTI/csv?clientName=${clientName||""}&dateFrom=${dateFrom||null}&dateTo=${dateTo||null}&statusID=${statusID||""}`,
            'GET', false)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Download Error: ${getErrorMessage({x})}`);
        }
        else{
          x.data.blob().then(blob => {
              FileSaver.saveAs(blob, `${moment().format('YYYYMMDD_HHMMSS')}_RCTI_rebates.csv`);
          });   
        } 
        return x;
      });
  };
}

export function downloadRebatesRCTI({id}){
  return function (dispatch) {
    return apiRequest(`/api/rebateRCTI/pdf?id=${id}`,'GET', false)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Download Error, error: ${getErrorMessage({x})}`);
        }
        else{
          x.data.blob().then(blob => {
              FileSaver.saveAs(blob, `${moment().format('YYYYMMDD_HHMMSS')}_RCTI_rebates.pdf`);
          });   
        } 
        return x;
      });
  };
}

export function listRebatesRCTIStatus() {
  return function (dispatch) {
    return apiRequest(`/api/rebateRCTI/exportstatus`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Rebates RCTI Status Error, error: ${getErrorMessage({x})}`);
        } 
        return x;
      });
    }
}

export function createRebatesRCTI({payLoad}) {
  return function () {
    toastr.info(`${payLoad && payLoad.id ? "Updating...":"Creating..."}`);
    return apiPost(`/api/rebateRcti`, payLoad)
      .then(x => {
        return x;
      });
  };
}

export function updateRebatesRCTI({payLoad}) {
  return function () {
    toastr.info("Updating...");
    return apiPost(`/api/rebateRcti`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Update Error: ${getErrorMessage({x})}`);
        } 
        return x;
      });
  };
}

export function exportRebatesAsCsv({dateFrom, dateTo, clientId}) {
  return function (dispatch) {
    toastr.info("Exporting as CSV");
    let selectedClients = mustBeArray(clientId).includes("All") || _.isEmpty(mustBeArray(clientId)) ? `clientId=${""}` : mustBeArray(clientId).reduce((a,b) => {
      return a ? `${a}&clientId=${b}` : `clientId=${b}`;
    },"");
    const url = `/api/rebatercti/clientlocations/csv?${selectedClients}&dateFrom=${dateFrom||null}&dateTo=${dateTo||null}`;
    return apiRequest(url,"GET",false)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Export Error, ${getErrorMessage({x})}`);
        }
        else{
          x.data.blob().then(blob => {
              FileSaver.saveAs(blob, `${moment().format('YYYYMMDD_HHMMSS')}_RCTI_rebates.csv`);
          });   
        } 
        return x;
      });
    };
}

export async function cancelRebatesRCTI(id = "") {
  await request.put(`/api/rebatercti/${id}/cancel`);
}